import * as React from 'react'
import { FC, useEffect, useState } from 'react'
import { navigate } from 'gatsby'
import SvgIcon from '../SVGIcon/SvgIcon'
import Button from '../Button/Button'
import { Colors } from '../../utils/constants'
import { cls } from '../../utils/utils'
import { tagUrlify } from '../../utils/utils'
import { ISearch } from './SearchBar.types'
import * as styles from './SearchBar.module.scss'

const SearchBar: FC<ISearch> = ({ selectedTag, searchQuery, root }) => {
  const [inputValue, setInputValue] = useState('')

  useEffect(() => {
    setInputValue(searchQuery)
  }, [])

  const changePage = (currentQuery?: string) => {
    if (selectedTag) {
      void navigate(`/${root}/${tagUrlify(selectedTag)}/?search=${currentQuery || ''}`)
    } else {
      if (currentQuery) void navigate(`/${root}/all-items/?search=${currentQuery}`)
      else void navigate(`/${root}`)
    }
  }

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    changePage(inputValue)
  }

  return (
    <form className={styles.form} onSubmit={(e) => handleSubmit(e)}>
      <input
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        type="text"
        placeholder="Search"
        className={styles.search}
      />
      <div className={styles.iconWrapper}>
        <SvgIcon href="/images/search.svg#icon" className={cls(styles.icon, (searchQuery || inputValue) && styles.active)} />
      </div>
      <Button
        type="submit"
        btnStyle={Colors.GREY}
        className={cls(styles.searchButton, (searchQuery || inputValue) && styles.searchButtonActive)}
        disabled={!(searchQuery || inputValue)}
      >
        Search
      </Button>
    </form>
  )
}

export default SearchBar
